export default __webpack_public_path__ + "static/media/system_builder_lipid_panel.e1f43a6b.png";